export default __webpack_public_path__ + "static/media/Physcadellic.929c9e88.jpg";